
import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Overlay from '../components/Overlay'
import HeroCarousel3D from '../components/HeroCarousel3D'
import AppDownloadModal from '../components/AppDownloadModal'
import InfoGridModal from '../components/InfoGridModal'
import HomeLockModal from '../components/HomeLockModal'

const Index = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user, loading } = useAuth()

  const [viewport, setViewport] = useState(window.innerWidth)
  const isMobile = viewport <= 768 ||
  (viewport <= 950 && window.innerHeight <= 500 && window.innerWidth > window.innerHeight)

  const [landingPageLocked, setLandingPageLocked] = useState(null)
  const [indexUnlocked, setIndexUnlocked] = useState(false)

  const [carouselKey, setCarouselKey] = useState(0)
  const [showDownloadModal, setShowDownloadModal] = useState(false)
  const wasMaximized = useRef(null)

  useEffect(() => {
    const onResize = () => setViewport(window.innerWidth)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    const loadLandingPageLock = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/company/landing-page-lock`
        )

        if (!response.ok) {
          throw new Error('Chyba pri načítaní stavu stránky')
        }

        const data = await response.json()
        setLandingPageLocked(data.locked === true)
      } catch (error) {
        console.error(error)
        setLandingPageLocked(false)
      }
    }

    loadLandingPageLock()
  }, [])

  useEffect(() => {
    if (
      !loading &&
      user &&
      landingPageLocked !== null &&
      (!landingPageLocked || indexUnlocked)
    ) {
      navigate('/home', { replace: true })
    }
  }, [
    user,
    loading,
    navigate,
    landingPageLocked,
    indexUnlocked
  ])

  useEffect(() => {
    const checkWindowState = () => {
      const isMaximized =
        window.outerWidth >= window.screen.availWidth &&
        window.outerHeight >= window.screen.availHeight

      if (wasMaximized.current === null) {
        wasMaximized.current = isMaximized
        return
      }

      if (wasMaximized.current !== isMaximized) {
        setCarouselKey(prev => prev + 1)
      }

      wasMaximized.current = isMaximized
    }

    checkWindowState()
    window.addEventListener('resize', checkWindowState)

    return () => {
      window.removeEventListener('resize', checkWindowState)
    }
  }, [])

  const [showInfoModal, setShowInfoModal] = useState(true)
  const [isLoading] = useState(false)

  return (
    <>
      <Overlay
        open={isLoading}
        blockClose
        backdropOpacity={0.75}
        zIndex={3000}
      >
        <div
          style={{
            background: '#fff',
            padding: 24,
            borderRadius: 12,
            boxShadow: '0 12px 28px rgba(0,0,0,0.6)',
            fontSize: 15,
            fontWeight: 500
          }}
        >
          {t('PLEASE_WAIT') || 'Prosím čakajte...'}
        </div>
      </Overlay>

      <div
        style={{
          textAlign: 'center',
          marginTop: isMobile
            ? 0
            : 'clamp(40px, 6vh, 80px)',
          width: isMobile ? '100%' : undefined,
          maxWidth: isMobile ? '100%' : undefined,
          minWidth: 0,
          boxSizing: 'border-box'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: isMobile ? 'stretch' : 'flex-start',
            gap: isMobile ? 24 : 40,
            marginTop: isMobile ? 0 : 40,
            width: isMobile ? '100%' : undefined,
            maxWidth: isMobile ? '100%' : undefined,
            minWidth: 0,
            boxSizing: 'border-box'
          }}
        >
          <InfoGridModal
            open={showInfoModal}
            onClose={() => setShowInfoModal(false)}
          />

          <div
            style={{
              flex: isMobile ? '0 1 auto' : '0 0 auto',
              width: isMobile ? '100%' : undefined,
              maxWidth: isMobile ? '100%' : undefined,
              minWidth: 0,
              boxSizing: 'border-box',
              display: isMobile ? 'flex' : undefined,
              justifyContent: isMobile ? 'center' : undefined
            }}
          >
            <HeroCarousel3D
	  key={carouselKey}
	  onClick={() => setShowDownloadModal(true)}
	/>
          </div>
        </div>
      </div>

      {landingPageLocked === true && (
        <HomeLockModal
          open={!indexUnlocked}
          onUnlock={() => setIndexUnlocked(true)}
        />
      )}
      <AppDownloadModal
        open={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
      />
    </>
  )
}

export default Index
